import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useHighlightedText } from 'hooks/useHighlightedText';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { truncateText } from 'utils/ui';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Similar to Markdown, we treat each line break as a new paragraph
// When the user inserts two or more consecutive line breaks in the text field, we only display one line break in the UI (e.g., HoverDescription). (screenshot: https://github.com/5app/hub/pull/13236)

// The `getParagraphs` function is to return an array (i.e., `paragraphs`) by
// 1) taking the provided text (string);
// 2) remove mutliple line breaks;
// 3) create subarrays for each paragraph, which is separated by an empty string. e.g., ['one', 'two', '', 'three', '', 'four', 'five', 'six'] => [['one', 'two'], ['three'], ['four', 'five', 'six']]

function getParagraphs(text) {
  var isPreviousEmpty = false;
  var splitByLine = text.split(/\r?\n|\r|\n/g).filter(function (line) {
    if (line !== '') {
      isPreviousEmpty = false;
      return true;
    }
    if (!isPreviousEmpty) {
      isPreviousEmpty = true;
      return true;
    }
    return false;
  });
  var paragraphs = [];
  var currentSubParagraph = [];
  splitByLine.forEach(function (item) {
    if (item !== '') {
      currentSubParagraph.push(item);
    } else if (currentSubParagraph.length > 0) {
      paragraphs.push(currentSubParagraph);
      currentSubParagraph = []; // reset the subarray
    }
  });
  if (currentSubParagraph.length > 0) {
    paragraphs.push(currentSubParagraph);
  }
  return paragraphs;
}
var Paragraph = styled.p.withConfig({
  displayName: "UserGeneratedText__Paragraph",
  componentId: "sc-nzui0y-0"
})(["& + &{margin-top:", ";}"], function (p) {
  return p.theme.globals.spacing.s;
});
function LineBreaks(_ref) {
  var text = _ref.text;
  var _useHighlightedText = useHighlightedText(),
    highlightText = _useHighlightedText.highlightText;
  var paragraphs = useMemo(function () {
    return getParagraphs(text);
  }, [text]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: paragraphs.map(function (paragraph, i) {
      return /*#__PURE__*/_jsx(Paragraph, {
        children: paragraph.map(function (line, index) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [highlightText(line), paragraph.length - 1 !== index && /*#__PURE__*/_jsx("br", {})]
          }, index);
        })
      }, i);
    })
  });
}
function UserGeneratedText(_ref2) {
  var text = _ref2.text,
    _ref2$truncateLength = _ref2.truncateLength,
    truncateLength = _ref2$truncateLength === void 0 ? 0 : _ref2$truncateLength,
    _ref2$allowLineBreaks = _ref2.allowLineBreaks,
    allowLineBreaks = _ref2$allowLineBreaks === void 0 ? true : _ref2$allowLineBreaks;
  var _useHighlightedText2 = useHighlightedText(),
    highlightText = _useHighlightedText2.highlightText;
  if (truncateLength > 0 && !allowLineBreaks) {
    var shortened = truncateText(text, truncateLength);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: highlightText(shortened || '')
    });
  }
  if (!allowLineBreaks) {
    return /*#__PURE__*/_jsx("p", {
      children: highlightText(text)
    });
  }
  return /*#__PURE__*/_jsx(LineBreaks, {
    text: text
  });
}
export default UserGeneratedText;